var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7068 13.7068C11.5193 13.8942 11.2651 13.9997 11 14H1C0.734877 13.9997 0.4807 13.8942 0.293229 13.7068C0.105759 13.5193 0.000304367 13.2651 0 13V1C0.000304367 0.734877 0.105759 0.4807 0.293229 0.293229C0.4807 0.105759 0.734877 0.000304367 1 0H11C11.2651 0.000304367 11.5193 0.105759 11.7068 0.293229C11.8942 0.4807 11.9997 0.734877 12 1V13C11.9997 13.2651 11.8942 13.5193 11.7068 13.7068ZM1 1V13H11V1H1ZM8 8H2.5V9H8V8ZM2.5 10.5H6V11.5H2.5V10.5Z",
    fill: "#450A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.a44964689d889171fcfac3a2f428aa26.svg";
export { ForwardRef as ReactComponent };